export default {
    data() {
        return {
            currentPage: 1,
            itemsPerPage: 10,
            items: null,
        };
    },
    computed: {
        paginatedItems() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.items.slice(start, end);
        },
        totalPages() {
            this.currentPage = 1;
            if (this.items != null) {
                let nbPages = Math.ceil(this.items.length / this.itemsPerPage);
                if (nbPages == 0) {
                    return 1
                }
                return nbPages;
            }
        },
    },
    methods: {
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
    },
};